export interface provider {
	name: string;
	badgeImageSrc: string;
	badgeImageAlt: string;
	bannerImageSrc: string;
	bannerImageAlt: string;
	description: string;
	href: string;
	route: string;
}

export const providers: provider[] = [
  {
    name: 'Genesis Care',
    badgeImageSrc: 'https://pbs.twimg.com/profile_images/1015147528625573888/gxU9EtCu.jpg',
    badgeImageAlt: 'Genesis Care',
    bannerImageSrc:
			'https://mms.businesswire.com/media/20200515005414/en/791942/22/GenesisCare_Logo.jpg',
    bannerImageAlt: 'Genesis Care',
    description: 'We are really good at this certain thing.',
    href: '/gc',
    route: 'gc'
  },
  {
    name: 'OSU',
    badgeImageSrc:
			'https://d31029zd06w0t6.cloudfront.net/wp-content/uploads/sites/54/2020/11/web1_osufootball-6.jpg',
    badgeImageAlt: 'OSU Logo',
    bannerImageSrc:
			'https://static-assets.oncolens.com/images/customer-logos/osu-james-logo.jpg',
    bannerImageAlt: 'OSU Logo',
    description: 'We are really good at this certain thing.',
    href: '/osu',
    route: 'osu'
  }
];
